module.exports = __webpack_public_path__ + "img/SZ.13b58390.svg";